import { getAuthenticated } from '../../../../../services/RestTemplate';
import { objToUrlParams } from '../../../../../shared/helpers/url-params.helper';

export const alertsApi = '/alerts';

export function getAlerts(args) {
    const urlParams = objToUrlParams(args);
    const getAlertsUrl = alertsApi + urlParams;

    return getAuthenticated(getAlertsUrl);
}
